export default __webpack_public_path__ + "images/Sagittal_View_of_Cervix_with_Placenta_dark.cfd372bcdd6c22c6b579506dae4e39c3.png";